SNI.Application.addModule('full-width-promo', context => ({
  behaviors: ['lazy-load', 'multi-component-dynamic-ad', 'invoke-video-overlay', 'load-more']
}));
